import { useState, useEffect } from "react";
const EditableResultTextArea = ({
  result,
  edit,
  setEdit,
  changeTo,
  setValue,
  changed,
  autosave,
  type,
  placeholder = null,
  styleInput,
  styleText,
}) => {
  const [tempValue, setTempValue] = useState(changeTo);

  const handleEdit = () => {
    setEdit(true);
    setTempValue(changeTo);
  };
  const handleChange = (e) => {
    if (type == "number") {
      setTempValue(e.target.value);
    } else {
      setTempValue(e.target.value);
    }
  };

  const handleSaveChange = () => {
    setEdit(false);
    setValue(tempValue);
  };

  useEffect(() => {
    if (edit == true) setTempValue(changeTo);
  }, [edit]);

  useEffect(() => {
    if (autosave) {
      setValue(tempValue);
    }
  }, [tempValue]);
  return (
    <>
      {!edit ? (
        <h4 className={changed ? "__changed" : null} style={styleText}>
          {result}
        </h4>
      ) : (
        <input
          style={styleInput}
          type={type === "number" ? "number" : "text"}
          value={tempValue}
          placeholder={placeholder}
          onChange={(e) => handleChange(e)}
          className="custom__input"
          autoFocus
        />
      )}
      {!edit ? (
        <>
          {/* <EditIcon style={{ marginLeft: 20, cursor: "pointer", color: "#476355" }} onClick={()=> handleEdit()}/> */}
        </>
      ) : (
        <>
          {/* Save changes */}
          {/* <CheckIcon style={{ marginLeft: 20, cursor: "pointer" }} onClick={() => handleSaveChange()}/> */}
          {/* Discard changes */}
          {/* <CloseIcon style={{ marginLeft: 8, cursor: "pointer" }} onClick={()=> setEdit(false)}/> */}
        </>
      )}
    </>
  );
};

export default EditableResultTextArea;
